var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-card',{attrs:{"size":"small","title":"WS连接客户端IP流量监控明细统计"}}),_c('a-card',{attrs:{"size":"small"}},[_c('searchE',{on:{"handleSearch":_vm.handleSubmit}}),_c('tableE',{ref:"ipdeatilTableID"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }